<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/coupons'"
    [currentPageValue]="'Create New Coupon'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addCouponForm" (ngSubmit)="onAddCouponSubmit()">
        <h2>Basic Details</h2>
        <div class="divider"></div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-en-name">
                Coupon English Name
              </label>
              <input
                class="form-control"
                id="coupon-en-name"
                formControlName="enName"
                placeholder="Coupon English Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.enName.dirty) &&
                  addCouponForm.controls.enName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.enName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addCouponForm.controls.enName.errors.pattern">
                  This field accept only English characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-ar-name">
                Coupon Arabic Name
              </label>
              <input
                class="form-control"
                id="coupon-ar-name"
                formControlName="arName"
                placeholder="Coupon Arabic Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.arName.dirty) &&
                  addCouponForm.controls.arName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.arName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addCouponForm.controls.arName.errors.pattern">
                  This field accept only Arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-start-date">
                Coupon Start Date
              </label>
              <input
                class="form-control"
                id="coupon-start-date"
                formControlName="startDate"
                placeholder="Coupon Start Date"
                type="text"
                bsDatepicker
                [minDate]="fromMinDate"
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.startDate.dirty) &&
                  addCouponForm.controls.startDate.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.startDate.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-end-date">
                Coupon End Date
              </label>
              <input
                class="form-control"
                id="coupon-end-date"
                formControlName="endDate"
                placeholder="Coupon End Date"
                type="text"
                bsDatepicker
                [minDate]="toMinDate"
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.endDate.dirty) &&
                  addCouponForm.controls.endDate.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.endDate.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-discount">
                Discount Percentage
              </label>
              <input
                class="form-control"
                id="coupon-discount"
                formControlName="discountPercentage"
                placeholder="Discount Percentage"
                type="number"
                min="1"
                max="100"
              />
              <div
                *ngIf="
                  (isSubmited ||
                    addCouponForm.controls.discountPercentage.dirty) &&
                  addCouponForm.controls.discountPercentage.errors
                "
                class="input-errors"
              >
                <p
                  *ngIf="
                    addCouponForm.controls.discountPercentage.errors.required
                  "
                >
                  This field is required with value more than 0 and less than
                  100!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-ceiling">
                Coupon Ceiling
              </label>
              <input
                class="form-control"
                id="coupon-ceiling"
                formControlName="ceiling"
                placeholder="Coupon Ceiling"
                type="number"
                min="0"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.ceiling.dirty) &&
                  addCouponForm.controls.ceiling.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.ceiling.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-control-label" for="coupon-usage-type">
                Coupon Use
              </label>
              <select
                formControlName="usageType"
                class="form-control"
                id="coupon-usage-type"
              >
                <option [value]="couponUsageTypes.SingleUse">Single Use</option>
                <option [value]="couponUsageTypes.OncePerCustomer">Once Per Customer</option>
                <option [value]="couponUsageTypes.Unlimited">Unlimited</option>
              </select>
            </div>
          </div>
        </div>
        <h2 class="mt-3">Eligibility Criteria</h2>
        <div class="divider"></div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-doctor-type">
                Doctor Type
              </label>
              <select
                formControlName="doctorType"
                class="form-control"
                id="coupon-doctor-type"
              >
              <option [value]="doctorTypes.All">All Doctor Types</option>
              <option [value]="doctorTypes.Se7etak">Se7etak Doctors</option>
                <option [value]="doctorTypes.Normal">Normal Doctors</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-specialities">
                Specialties
              </label>
              <ng-multiselect-dropdown
                id="coupon-specialities"
                formControlName="specialities"
                [placeholder]="'Specialities'"
                [settings]="{
                  singleSelection: false,
                  enableCheckAll: true,
                  selectAllText: 'Select All',
                  unSelectAllText: 'All Specialities',
                  searchPlaceholderText: 'Search Speciality',
                  itemsShowLimit: 3,
                  idField: 'id',
                  textField: 'name',
                  allowSearchFilter: true,
                  closeDropDownOnSelection: false
                }"
                [data]="specialities"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="addCouponForm.invalid"
            >
              Save
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/coupons'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
